import script from "./study.vue?vue&type=script&setup=true&lang=js"
export * from "./study.vue?vue&type=script&setup=true&lang=js"

import "./study.vue?vue&type=style&index=0&id=636d7a73&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636d7a73"]])

export default __exports__